import { useState, createContext, useEffect } from "react";
import { useQuery } from "react-query";
import FullScreenSpinner from "../components/FullScreenSpinner";
import OnBoarding from "../components/OnBoarding";
import PendingApproval from "../components/PendingApproval";
import SignIn from "../components/SignIn";
import { auth, db } from "../firebase";

export const fetchOrCreateUser = async () => {
  if (auth.currentUser) {
    let currentUser;

    const snapshot = await db
      .collection("users")
      .doc(auth.currentUser.uid)
      .get();

    if (snapshot.exists) {
      currentUser = {
        id: snapshot.id,
        ...snapshot.data(),
      };
    } else {
      currentUser = {
        email: auth.currentUser?.email,
        displayName: auth.currentUser.displayName || "",
        firstName: auth.currentUser?.displayName?.split?.[0] || "",
        lastName: auth.currentUser?.displayName?.split?.[1] || "",
        dateCreated: Date.now(),
        region: "",
        role: "pending",
      };
      await db
        .collection("users")
        .doc(auth.currentUser.uid)
        .set(currentUser, { merge: true });
    }

    return currentUser;
  }

  return null;
};

export const AuthContext = createContext();

export const useCurrentUser = () =>
  useQuery({
    queryKey: "currentUser",
    queryFn: fetchOrCreateUser,
  });

export function AuthProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const userQuery = useCurrentUser();
  const { data, refetch } = userQuery;

  useEffect(() => {
    auth.onAuthStateChanged(async (authUser) => {
      if (authUser) {
        await refetch();
      }
      setIsLoading(false);
    });
  }, [refetch]);

  const render = () => {
    if (isLoading) return <FullScreenSpinner />;
    if (!data) return <SignIn />;
    if (data?.role === "pending") return <PendingApproval />;
    if (!data?.displayName || !data?.region) return <OnBoarding />;
    return children;
  };
  return (
    <AuthContext.Provider value={userQuery}>{render()}</AuthContext.Provider>
  );
}
